<template>
  <div class="order-list">
    <div v-if="!orders.length" class="order-404">
      您暂时没有订单！
    </div>
    <div class="order-item" v-for="order in orders" @click="goToDetail(order)" :key="order._id">
      <div class="order-no">
        <span class="order-name">订单编号：{{order._id}}</span>
        <span class="order-status">{{order.status | calStatus}}</span>
      </div>
      <div class="goods-item">
        <ul>
          <li v-for='(g,index) in order.products' :key="g._id+index">
            <p class="cart-item">
              <span>{{g.name}}{{g.spec ? ` [${g.spec}]`:""}}</span>
              <span class="price">¥{{Math.round(100*g.quantity * g.price)/100}}</span>
              <span class="quantity">&nbsp;&nbsp;&nbsp;&nbsp;{{g.quantity/Number((g.unit2 && g.priceTransfer || 1))}}{{g.unit2 || g.unit || '斤'}}</span>
              <span style="float: right; color: red" v-if="g.suppliers && g.suppliers[0] && g.suppliers[0] !== order.supplier._id">{{supplierMap[g.suppliers[0]]}}</span>
            </p>
          </li>
        </ul>
      </div>
      <div class="total-price">
          <span class="created_time">{{order.createTime | filterTime}}</span>
          <span :style="{ color: order.status !== 1 ? 'red': '#666'}">总计：¥{{order.roughPrice | safeNum}} | {{STATUS_MAP[order.status]}}</span>
      </div>
      <div class="order-info">
        <span>备注：{{order.notes}}</span>
      </div>
      <div class="order-info">
          <span class="customer">客户：{{order.customer && order.customer.name}}</span>
          <span class="supplier">供应商：{{order.supplier && order.supplier.name || '暂无'}}</span>
      </div>
      <div class="order-info">
          <span>下单人：{{order.placedBy.name}}{{" " + order.placedBy.phone}}</span>
      </div>
    </div>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../utils.scss";
    $base-color:#79BD50;
    .order-list {
      overflow: hidden;
    }
  .order-item {
    padding-left: px2rem(20px);
    background: white;
    margin-top: px2rem(10px);
    .order-no {
        border-bottom: 1px solid #e5e5e5;
        height: px2rem(44px);
        line-height: px2rem(44px);
        @include font-dpr(14px);
      .order-name {
        color: #333;
      }
      .order-status {
        color: #999;
        float: right;
        margin-right: px2rem(20px);
        &:after {
          content: ' ';
          display: inline-block;
          height: px2rem(15px);
          width: px2rem(15px);
          background: url("../assets/icon_arrow@2x.png") no-repeat;
          background-size: contain;
          margin-bottom: px2rem(-3px);
          margin-left: px2rem(7px);
         }
      }
    }
    .goods-item {
      border-bottom: 1px solid #e5e5e5;
      .cart-item {
        @include font-dpr(14px);
        color: #666;
        margin-top: px2rem(16px);
        padding: 0 px2rem(20px) 0  0 ;
        &:last-child {
            margin-bottom: px2rem(16px);
         }
         .quantity {
            float: right;
         }

         .price {
            float: right;
            width: px2rem(50px);
           text-align: right;
         }
      }
    }

    .total-price {
      height: px2rem(44px);
      line-height: px2rem(44px);
      color: #666;
      margin-right: px2rem(20px);
      .created_time {
        float: none;
      }
      span {
        float: right;
      }
    }
    .order-info {
      min-height: px2rem(30px);
      line-height: px2rem(30px);
      color: #666;
      margin-right: px2rem(20px);
      .supplier {
        float: right;
      }
    }

  }

    .order-404 {
      text-align: center;
      color: #666;
      @include font-dpr(14px);
      line-height: px2rem(30px);
  }


</style>

<script>
  import { host } from '../config'
  import utilMixin from './mixins/utils'

export default {
  name: 'hello',
  mixins: [utilMixin()],
  data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      STATUS_MAP: {
        '-1': '已取消',
        1: "待核对",
        2: '已核对',
        3: '已完成'
      },
      orders: [],
      suppliers: [],
    };
  },
  methods: {
    goToDetail(order) {
        this.$router.push('/support/order/' + order._id);
    },

  },
  created() {
      this.$http.get(host + '/api/support/order/list', {withCredentials: true}).then(res => {
        this.orders = res.data.data
      })
      this.$http.get(host + '/api/supplier/list', {withCredentials: true}).then(res => {
        this.suppliers = res.data.data
      })
      this.getLogin().then(res => {
        if (!res) {
          this.$router.push('/login')
        }
      })
  },
  computed: {
    supplierMap() {
      const map = {}
      this.suppliers.forEach(s => {
        map[s._id] = s.name
      })
      return map
    }
  },
  filters:{
      calStatus(val) {
          let res = ''
          switch(val){
              case "0":
                res='订单已失效';
                break;
              case "1":
                res='待支付';
                break;
              case "2":
                res ='支付成功';
                break;
              case "3":
                res = '已取消';
                break;
              case "4":
                res = '订单到付';
                break;
          }
          return res;
    }
  }
};
</script>




// WEBPACK FOOTER //
// SupportOrders.vue?0428e4ff